<div class="filter-row">
    <div class="filter-input-row flex-grow-1 row align-items-end">
        @for(item of filterFieldArray; track item.id){
        @switch (item.type) {
        @case ("input-search") {
        <div class="col-md-6 col-xxl-3 col-11">
            <label [for]="item.id" class="">{{item.title}}</label>
            <div class="input-group search-input">
                <span class="input-group-text rounded-3 rounded-end-0">
                    <i class="bi bi-search text-secondary"></i>
                </span>
                <input type="text" [id]="item.id" class="form-control rounded-3 rounded-start-0 bg-light-ks"
                    placeholder="..." [(ngModel)]="filterFieldMap()[item.id].value"
                    [attr.aria-label]="item.title"  autocomplete="item.title">
            </div>
        </div>
        }
        @case("select") {
        <div class="col-md-6 col-xxl-3 col-11">

            <label [for]="item.id" class="">{{item.title}}</label>
            <select [id]="item.id" class="form-select bg-light-ks" [attr.aria-label]="'Filtra per ' + item.title"
                [(ngModel)]="filterFieldMap()[item.id].value">
                <option value="">Tutti</option>
                @for(option of item.data; track option.id){
                <option [value]="option.id">{{option.name}}</option>
                }
            </select>
        </div>

        }
        @case("select-hidden") {

            <input type="hidden" class="form-control" style="display: none;"
                [(ngModel)]="filterFieldMap()[item.id].value">

        }
        @case("date-picker") {
        <div class="col-md-6 col-xxl-3 col-11">

            <label [for]="item.id" class="">{{item.title}}</label>
            <div class="d-flex">
                <input type="text" [id]="item.id" class="form-control date-picker bg-light-ks rounded-3 rounded-end-0"
                    placeholder="dd/mm/yyyy" appDatepicker [(ngModel)]="filterFieldMap()[item.id].value"
                    [attr.aria-label]="item.title">
                <span class="input-group-text rounded-3 rounded-start-0 color-picker-span"><i
                        class="bi bi-calendar"></i></span>
            </div>
        </div>

        }
        @case('select-with-search'){
        <div class="col-md-6 col-xxl-3 col-11">

            <label [for]="item.id" class="">{{item.title}}</label>
            <ngx-select-dropdown class="bg-light-ks select-search" [(ngModel)]="filterFieldMap()[item.id].value"
                [config]="configSelectSearch" [options]="item.data">
            </ngx-select-dropdown>
        </div>

        }
        }
        }
    </div>
    <div class="col-2 button-column">
        <button type="submit" class="btn btn-primary-ks" (click)="emitFilters()">Filtra</button>
    </div>
</div>